import React, { FC } from 'react';
import {
  StatsList,
  StatFigure,
  StatDescription,
  SharedProps,
  StatSource,
} from './StatsBlock.styles';

export type StatsComponentProps = SharedProps & {
  stats: {
    figure: string;
    description: string;
    sourceTitle?: string;
    sourceLink?: string;
  }[];
};

const Stats: FC<StatsComponentProps> = ({ type, size, stats }) => {
  return (
    <StatsList type={type} size={size}>
      {stats.map((stat) => (
        <div key={stat?.description}>
          <StatFigure>{stat.figure}</StatFigure>
          <StatDescription>
            {stat.description}
            {stat.sourceTitle && (
              <StatSource>
                {stat.sourceLink ? (
                  <a
                    href={stat.sourceLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {stat.sourceTitle}
                  </a>
                ) : (
                  <span>{stat.sourceTitle}</span>
                )}
              </StatSource>
            )}
          </StatDescription>
        </div>
      ))}
    </StatsList>
  );
};

export default Stats;
